"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHistory = void 0;
const react_1 = require("react");
function useHistory(url) {
    const context = (0, react_1.useMemo)(() => ({
        url,
    }), [url]);
    return { context };
}
exports.useHistory = useHistory;
//# sourceMappingURL=history-hook.js.map